"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.demoPageQuerySet = void 0;
var _search = require("../search");
const demoPageQuerySet = exports.demoPageQuerySet = {
  ..._search.searchQuerySet,
  known: {
    ..._search.searchQuerySet.known,
    // Form Metadata Params
    formType: {
      type: "enum",
      values: {
        global: "global",
        contentbased: "contentbased",
        alacarte: "alacarte"
      }
    },
    contentType: {
      type: "enum",
      values: {
        category: "category",
        collection: "collection"
      }
    },
    formId: {
      type: "string"
    },
    modules: {
      type: "string"
    },
    debug: {
      type: "bool",
      default: false
    },
    // Form Config
    ssr: {
      type: "enum",
      values: {
        on: "on",
        off: "off"
      },
      default: "on"
    },
    submitAction: {
      type: "enum",
      values: {
        slider: "slider",
        results: "results"
      },
      default: "slider"
    },
    dist: {
      type: "enum",
      values: {
        mf: "module-federation",
        webpart: "webpart"
      }
    },
    instanceId: {
      type: "string",
      default: "default"
    },
    // UI Customization
    submitButtonText: {
      type: "string"
    },
    submitButtonSize: {
      type: "enum",
      values: {
        sm: "sm",
        lrg: "lrg",
        lrgr: "lrgr"
      }
    },
    submitButtonColor: {
      type: "enum",
      values: {
        silver: "silver",
        green: "green"
      }
    },
    formInputsSize: {
      type: "enum",
      values: {
        large: "large",
        largest: "largest"
      }
    },
    controlButtonsWidth: {
      type: "enum",
      values: {
        full: "full",
        "full-sm": "full-sm",
        "full-md": "full-md"
      }
    }
  }
};